import { render, staticRenderFns } from "./FilesWindow.vue?vue&type=template&id=59839dee&scoped=true&"
import script from "./FilesWindow.vue?vue&type=script&lang=js&"
export * from "./FilesWindow.vue?vue&type=script&lang=js&"
import style0 from "./FilesWindow.vue?vue&type=style&index=0&id=59839dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59839dee",
  null
  
)

export default component.exports